import { styled } from 'styled-components';

export const ChevronWrapper = styled.div`
  svg {
    transition: ${({ theme }) =>
      `transform ${theme.animation.duration.default} ${theme.animation.easing.moving}`};
    ${({ $isOpen }) => $isOpen && `transform: rotate(180deg)`};
  }
`;
